<template>
	<div class="pages" v-loading="listLoading">
		<div v-for='(item,index) in templateData.TemplateContent.Controls' :key='index'>
			<Digit v-if='item.Property.Control=="Number"' :data-val='item'></Digit>
			<Contact v-if='item.Property.Control=="Condition"' :data-val="item"></Contact>
			<Dates v-if='item.Property.Control=="Date"' :data-val="item"></Dates>
			<Version v-if='item.Property.Control=="Text"' @child-event='getTextVal' :data-val="item"></Version>
			<Money v-if='item.Property.Control=="Money"' :data-val="item"></Money>
			<Tips v-if='item.Property.Control=="Tips"' :data-val="item"></Tips>
			<File v-if='item.Property.Control=="File"' :data-val="item"></File>
			<Table v-if='item.Property.Control=="Table"' @child-event='tableOperation' :data-val='item'></Table>
			<Selector v-if='item.Property.Control=="Selector"' @child-event='getSelectorVal' :data-val='item'></Selector>
			<Textarea v-if='item.Property.Control=="Textarea"' :data-val='item'></Textarea>
			<Choose v-if='item.Property.Control=="Contact"' @child-event='clickChoose' :data-val='item'></Choose>
		</div>


		<Button class="submit-process" v-on:click='submit' v-bind:loading="formLoading" size="large" type="primary"> 提交
		</Button>
	</div>
</template>

<script>
	/**
	 * Version 为Text文本组件
	 */
	import Digit from '../components/Number.vue'
	import Contact from '../components/Contact.vue';
	import Dates from '../components/Date.vue';
	import Version from '../components/Text.vue';
	import Money from '../components/Money.vue';
	import Tips from '../components/Tips.vue';
	import File from '../components/File.vue';
	import Table from '../components/Table.vue';
	import Selector from '../components/Selector.vue';
	import Textarea from '../components/Textarea.vue';
	import Choose from '../components/Choose.vue';
	import wx from 'weixin-js-sdk'
	import stringUtils from "../assets/js/stringUtil.js";
	import {
		initWxConfig
	} from '../api/jssdk.js';
	import {
		getTemplateInfo,
		submitProcess
	} from '@/api/approval'
	import {
		getRelation
	} from '@/api/employee'

	import {
		getDepartmentRelationByName,
		GetDepartmentByDepId,
		getDepartmentInfo,
		getDepartmentRelationById
	} from '@/api/department'

	var isSubmit = false;

	var template = {
		TemplateContent: {
			Controls: []
		}
	};
	export default {
		components: {
			Contact,
			Dates,
			Version,
			Money,
			Tips,
			File,
			Table,
			Digit,
			Selector,
			Textarea,
			Choose
		},
		data() {
			return {
				templateData: template,
				relationList: null,
				logInfo: null,
				templateId: "",
				spNo: null,
				formLoading: false,
				listLoading: false
			}
		},
		created() {
			initWxConfig(this);
			this.logInfo = this.getLoginUserInfo();
			this.templateId = this.$route.query.templateId;
			this.spNo = this.$route.query.spNo;
			this.getEmployeeRelation();
			stringUtils.setAddIsShow(true);
		},
		methods: { //方法

			clickChoose(dataVal, name) {
				window.wx.invoke("selectEnterpriseContact", {
					"fromDepartmentId": 0, // 必填，表示打开的通讯录从指定的部门开始展示，-1表示自己所在部门开始, 0表示从最上层开始
					"mode": "single", // 必填，选择模式，single表示单选，multi表示多选
					"type": ["user"], // 必填，选择限制类型，指定department、user中的一个或者多个
					"selectedDepartmentIds": [], // 非必填，已选部门ID列表。用于多次选人时可重入，single模式下请勿填入多个id
					"selectedUserIds": [] // 非必填，已选用户ID列表。用于多次选人时可重入，single模式下请勿填入多个id
				}, function(res) {
					if (res.err_msg == "selectEnterpriseContact:ok") {
						if (typeof res.result == 'string') {
							res.result = JSON.parse(res.result) //由于目前各个终端尚未完全兼容，需要开发者额外判断result类型以保证在各个终端的兼容性
						}
						var user = res.result.userList[0];
						dataVal.Values.push([user.id, user.name]);
						dataVal.Value = user.name;
					}
				})
			},
			getTemplate: async function() {
				this.listLoading = true;
				var title = this.logInfo.fullName;
				var jobLevel = this.logInfo.JobLevel;
				var that = this;
				var departFullName = this.logInfo.fullName;
				getTemplateInfo(this.templateId).then(async response => {
					var controls = response.Body;
					this.templateData = this.assignControl(controls, this.logInfo);
					this.templateData.TemplateContent.Controls.forEach(async (item) => {
						var departs = this.logInfo.fullName.split("/");
						if (item.Property.Title[0].Text == "流程条件") {
							if (departs.indexOf("住宅部") > -1) {
								if (jobLevel == 6) {
									item.Value = 2.9
								} else if (jobLevel > 6) {
									item.Value = 2;
								} else {
									var isMatch = this.getSuperiorIsMatchDepth(this.relationList, 6, 1);
									if (isMatch) {
										item.Value = 2.9;
									} else {
										item.Value = this.getCondtion(this.relationList, 6, 2);
									}
								}
							}
							if (departs.indexOf("工商铺商业运营中心") > -1) {
								if (jobLevel >= 6) {
									item.Value = 3
								} else {
									var isMatch = this.getSuperiorIsMatchDepth(this.relationList, 6, 1);
									if (isMatch) {
										item.Value = 3;
									} else {
										item.Value = this.getCondtion(this.relationList, 6, 3);
									}
								}
							}
							if (departs.indexOf("二级市场营运中心") > -1 || departs.indexOf("代理") > -1) {
								if (jobLevel >= 7) {
									item.Value = 4
								} else {
									var isMatch = this.getSuperiorIsMatchDepth(this.relationList, 7, 1);
									if (isMatch) {
										item.Value = 4;
									} else {
										item.Value = this.getCondtion(this.relationList, 8, 4);
									}
								}
							}
							if (departs.indexOf("非营业部") > -1) {
								if (jobLevel >= 8) {
									item.Value = 5
								} else {
									var isMatch = this.getSuperiorIsMatchDepth(this.relationList, 8, 1);
									if (isMatch) {
										item.Value = 5;
									} else {
										item.Value = this.getCondtion(this.relationList, 8, 5);
									}
								}
							}
							if (departs.indexOf("按揭金融服务中心") > -1) {
								if (jobLevel >= 7) {
									item.Value = 6
								} else {
									var isMatch = this.getSuperiorIsMatchDepth(this.relationList, 7, 1);
									if (isMatch) {
										item.Value = 6;
									} else {
										item.Value = this.getCondtion(this.relationList, 7, 6);
									}
								}
							}

						}
						if (item.Property.Title[0].Text == "逐级审批") {
							console.log(1)
							item.Values = [];
							//item.Values.push(that.$store.state.defaultMember);
							console.log('departs',departs);
							item.IsShow = false;
							if (departs.indexOf("按揭金融服务中心") > -1) {
								item.Values.push(that.$store.state.defaultMember);
							} else if (departs.indexOf("房友圈") > -1 || departs.indexOf("二级市场营运中心") > -1 || departs.indexOf("代理") > -1) {
								item.Values = this.getRelationList(this.relationList, 8, "钟志斌");
							} else if (departs.indexOf("工商铺") > -1 || departs.indexOf("住宅部") > -1) {
								item.Values = this.getRelationList(this.relationList, 6, "钟志斌");
							}
						}
						if (item.Property.Title[0].Text == "大区董事") {
							item.IsShow = false;
							item.Values = [];
							await getDepartmentRelationByName(departFullName, true).then(res => {
								if (res.Body != null) {
									res.Body[0].Nodes.forEach((depData) => {
										if (depData.Items != null) {
											depData.Items.forEach((userData) => {
												if (userData.PositionName.indexOf("战区董事") > -1) {
													var insertDat = [userData.EmpNo, userData.EmpName]
													item.Values.push(insertDat);
												}
											})
										}
									});
								} else {
									item.Values = [
										["SC24000029", "钟志斌"]
									]
								}
								if (item.Values == null || item.Values.length == 0) {
									item.Values = [
										["SC24000029", "钟志斌"]
									]
								}
							});
						}
						if (item.Property.Title[0].Text == "大区总经理") {
							item.IsShow = false;
							item.Values = [];
							await getDepartmentRelationByName(departFullName, true).then(res => {
								if (res.Body != null) {
									res.Body[0].Nodes.forEach((depData) => {
										if (depData.Items != null) {
											depData.Items.forEach((userData) => {
												if (userData.PositionName.indexOf("董事总经理") > -1) {
													var insertDat = [userData.EmpNo, userData.EmpName]
													item.Values.push(insertDat);
												}
											})
										}
									});
								} else {
									item.Values = [
										["SC24000029", "钟志斌"]
									]
								}
								if (item.Values == null || item.Values.length == 0) {
									item.Values = [
										["SC24000029", "钟志斌"]
									]
								}
							});
						}
						if (item.Property.Title[0].Text == "流程编号") {
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "选择类型") {
							if (title.indexOf("按揭金融服务中心") > -1) {
								item.Property.Require = 0;
							} else {
								item.Property.Require = 1;
							}
						}
						if (item.Property.Title[0].Text == "部门") {
							var departs = title.split("/");
							if (departs.indexOf("华西区") > -1) {
								item.Value = departs[departs.indexOf("华西区") + 1] + "/" + this.logInfo.DeptName;
							}
							if (departs.indexOf("非营业部") > -1) {
								item.Value = departs[departs.indexOf("非营业部") + 1] + "/" + this.logInfo.DeptName;
							}
							if (departs.indexOf("营业部") > -1) {
								item.Value = departs[departs.indexOf("营业部") + 1] + "/" + this.logInfo.DeptName;
							}

							if (departs.indexOf("其他") > -1) {
								item.Value = departs[departs.indexOf("其他") + 1] + "/" + this.logInfo.DeptName;
							}
						}
					});
					this.templateData = await this.assignControlBySpNo(controls, this.spNo);
					this.listLoading = false;
				});
			},
			getEmployeeRelation() {
				getRelation(this.logInfo.EmpNo).then(response => {
					this.relationList = response.Body[0].Nodes;
				});
			},
			getTextVal() {},
			getSelectorVal(val, name) {},
			tableOperation(val, type, datas) {
				if (type == 'compute') {
					return;
				}
				this.tableoperation(val, type, datas, this);
			},
			submit() {
				//数据校验
				if (!this.submitValidate(this.templateData.TemplateContent.Controls)) {
					return;
				}
				if (isSubmit) {
					this.Message({
						message: '已提交',
						type: 'warning',
						duration: 1000
					});
					return;
				}
				isSubmit = true;
				this.listLoading = true;

				var SummaryList = [];
				var info = {
					SummaryInfo: []
				}
				info.SummaryInfo = [];

				var control1 = this.templateData.TemplateContent.Controls.filter(t => {
					return t.Property.Title[0].Text == "项目名称"
				})[0]
				if (control1.Value != null && control1.Value.length > 0) {
					var info = {
						SummaryInfo: []
					}
					info.SummaryInfo = [];
					info.SummaryInfo.push({
						"Text": "内容：" + control1.Value,
						"Lang": "zh_CN"
					});
					SummaryList.push(info);
				}

				var control2 = this.templateData.TemplateContent.Controls.filter(t => {
					return t.Property.Title[0].Text == "部门"
				})[0]
				var info = {
					SummaryInfo: []
				}
				info.SummaryInfo = [];
				info.SummaryInfo.push({
					"Text": "申请部门：" + control2.Value,
					"Lang": "zh_CN"
				});
				SummaryList.push(info);


				var data = new Date();
				var month = data.getMonth() < 9 ? "0" + (data.getMonth() + 1) : data.getMonth() + 1;
				var date = data.getDate() <= 9 ? "0" + data.getDate() : data.getDate();
				var dateTime = data.getFullYear() + "-" + month + "-" + date;
				var info = {
					SummaryInfo: []
				}
				info.SummaryInfo = [];
				info.SummaryInfo.push({
					"Text": "申请时间：" + dateTime,
					"Lang": "zh_CN"
				});
				SummaryList.push(info);
				this.templateData.SummaryList = SummaryList;

				//提交
				submitProcess(this.templateId, this.logInfo.EmpNo, this.spNo, this.templateData).then(response => {
					this.Message({
						message: '申请成功',
						type: 'success',
						duration: 3 * 1000
					});
					setTimeout(() => {
						this.$router.push("/index");
					}, 3000)
				}).finally(() => {
					isSubmit = false;
					this.listLoading = false;
				});
			}
		},
		watch: {
			relationList: 'getTemplate'
		}
	}
</script>

<style scoped lang="less">
	.pages {
		padding-bottom: 14px;
	}
</style>
